import $ from 'jquery';
import Addresses from './TemplateAddresses';

export default class TemplateAccount {
  constructor(section) {
    this.$el = $(section.el);
    $('.toggle-forgetfulness span', this.$el).on('click', () => this.recoverPassword());

    if ($(document.body).hasClass('template-customers-addresses')) {
      this.addressesView = new Addresses({ el: ($('.main-content')) });
    }

    if ($(document.body).hasClass('template-customers-login')) { this.checkForReset(); }

    if (window.location.hash === '#recover') { this.recoverPassword(); }
  }

  recoverPassword() {
    $('.recover-password').toggle();
    $('.customer-login').toggle();
  }

  checkForReset() {
    if ($('.reset-check').data('successful-reset') === true) {
      $('.successful-reset').show();
    }
  }
}
